const DELAY = 250; // ms before first logo fades in after list enters viewport
const DURATION = 2000; // ms per logo fade
const STAGGER = 75; // ms between each logo

class ClientExperienceLogos extends HTMLElement {
  connectedCallback() {
    this.logos = [...this.querySelectorAll(".client-experience__logo")];

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          this.animateLogos();
        });
      },
      { rootMargin: "0% 0% 0% 0%" },
    );

    this.observer.observe(this);
  }

  animateLogos() {
    const shuffled = this.logos.slice().sort(() => Math.random() - 0.5);

    setTimeout(() => {
      shuffled.forEach((logo, i) => {
        setTimeout(() => {
          logo.style.transitionDuration = `${DURATION}ms`;
          logo.style.opacity = "1";
        }, i * STAGGER);
      });
    }, DELAY);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get("client-experience-logos")) {
  customElements.define("client-experience-logos", ClientExperienceLogos);
}
